<template>
	<div>
		<!-- <a
			href="#"
			class="nk-button nk-button-gray"
			v-if="locations.available.length && locations.available.length > 1 && activities.selected"
			@click.prevent="toggleSelectingLocation"
			:class="{
				'link-plus-right': !ui.selectingLocation,
				'link-close-right': ui.selectingLocation || locations.selected,
			}"
		>
			<span
				v-if="locations.selected"
				v-html="formatLocationNameInList(locations.selected)"
				class="inner-text"
			></span>
			<span v-if="!locations.selected">Plats</span>
		</a>
		<a
			href="#"
			class="nk-button nk-button-gray nk-button-inactive"
			@click.prevent=""
			v-if="locations.available.length && locations.available.length < 1 && activities.selected"
			>Plats
			<img
				class="loading-spinner"
				src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
			/>
		</a> -->
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	computed: {
		...mapState(["ui", "locations", "activityGroups", "activities"]),
		...mapGetters([]),
	},
	methods: {
		...mapActions(["toggleSelectingLocation"]),
		formatLocationNameInList(name) {
			return this.$store.getters.formatLocationNameInList(name);
		},
	},
};
</script>